export default "__VITE_ASSET__ibwU9rCQ__"